import { CompetitionGenderEnum } from 'types/generated/server';
import toTitleCase from './toTitleCase';

const formatRating = (rating: number) => rating.toFixed(2).replace(/0$/, '');

const includeRatingData = ({
  minRating,
  maxRating,
}: {
  minRating?: number;
  maxRating?: number;
}) => {
  if (minRating && maxRating) {
    return `${formatRating(minRating)}-${formatRating(maxRating)}`;
  } else if (minRating) {
    return `${formatRating(minRating)}`;
  } else if (maxRating) {
    return `${formatRating(maxRating)}`;
  } else {
    return '';
  }
};

export const buildTournamentEventName = (opts: {
  gender: CompetitionGenderEnum;
  eventType: string;
  minRating?: number;
  maxRating?: number;
  isWheelchair?: boolean;
  isMoneyBall?: boolean;
}) => {
  let gender;
  switch (opts.gender) {
    case CompetitionGenderEnum.Male:
      gender = "Men's";
      break;
    case CompetitionGenderEnum.Female:
      gender = "Women's";
      break;
    case CompetitionGenderEnum.Mixed:
      gender = 'Mixed';
      break;
    case CompetitionGenderEnum.Coed:
      gender = 'Co-Ed';
      break;
    default:
      gender = '';
      break;
  }

  const base = `${gender} ${opts.eventType} ${includeRatingData(opts)}`.trim();
  const suffixes = [opts.isWheelchair && 'Wheelchair', opts.isMoneyBall && 'Money Ball'].filter(
    Boolean,
  ) as string[];
  return suffixes.length ? `${base} • ${suffixes.join(' • ')}` : base;
};

export const buildTournamentEventNameWithoutGender = (opts: {
  title: string;
  eventType: string;
  minRating?: number;
  maxRating?: number;
}) => {
  return `${toTitleCase(opts?.title)} ${opts.eventType} ${includeRatingData(opts)}`.trim();
};
